// Helps to convert distance; from meters to km
import { JsonConverter, JsonCustomConvert } from 'json2typescript';
import { roundTo } from '../../util/general';

@JsonConverter
export default class DistanceConverter implements JsonCustomConvert<number> {
  serialize = (num:number) => num * 1000;
  deserialize = (num:number) => num !== 0 ? roundTo(num / 1000)  : 0;
}